// document.addEventListener('DOMContentLoaded', function () {
//   const btn  = document.querySelector('button.custom-site-header-right-search');
//   const form = document.querySelector('form.live-search-form.form-fields-inline');
//   const promos = document.querySelector('.custom-promos-wrapper');

//   if (!btn || !form) return;

//   btn.addEventListener('click', function (e) {
//     e.preventDefault();
//     form.classList.toggle('is-open');
//     promos.classList.toggle('custom-hidden');
//   });
// });
// document.addEventListener('DOMContentLoaded', function () {
//     var toggleBtn = document.getElementById('custom-site-account-toggle-button');
//     var menu = document.getElementById('custom-login-menu');
  
//     if (!toggleBtn || !menu) return;
  
//     function closeMenu() {
//       menu.classList.remove('is-visible');
//       menu.classList.add('is-hidden');
//       toggleBtn.setAttribute('aria-expanded', 'false');
//     }
  
//     function openMenu() {
//       menu.classList.add('is-visible');
//       menu.classList.remove('is-hidden');
//       toggleBtn.setAttribute('aria-expanded', 'true');
//     }
  
//     toggleBtn.addEventListener('click', function (event) {
//       event.stopPropagation();
  
//       var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
//       if (isOpen) {
//         closeMenu();
//       } else {
//         openMenu();
//       }
//     });
  
//     // Close when clicking outside
//     document.addEventListener('click', function (event) {
//       if (!menu.contains(event.target) && !toggleBtn.contains(event.target)) {
//         closeMenu();
//       }
//     });
  
//     // Close on Escape key
//     document.addEventListener('keydown', function (event) {
//       if (event.key === 'Escape') {
//         closeMenu();
//       }
//     });
//   });
//   var flkty = new Flickity( '.custom-promos-wrapper.custom-mobile-promos', {
//     freeScroll: true,
// contain: true,
// prevNextButtons: false,
// pageDots: false,
// watchCSS: true
//   });
//   document.addEventListener('DOMContentLoaded', function() {
//     // Small delay to ensure CSS is fully loaded and applied
//     setTimeout(function() {
//       var custom_content_slider = new Flickity('.custom-content-slider-slider', {
//         freeScroll: false,
//         contain: true,
//         prevNextButtons: true,
//         pageDots: true,
//         wrapAround: true,
//         cellAlign: 'left',
//       });
//     }, 100);
//   });
document.addEventListener('DOMContentLoaded', function () {

  // --- Search toggle ---
  const btn  = document.querySelector('button.custom-site-header-right-search');
  const form = document.querySelector('form.live-search-form.form-fields-inline');
  const promos = document.querySelector('.custom-promos-wrapper');

  if (btn && form) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      form.classList.toggle('is-open');
      promos.classList.toggle('custom-hidden');
    });
  }

  // --- Account menu toggle ---
  var toggleBtn = document.getElementById('custom-site-account-toggle-button');
  var menu = document.getElementById('custom-login-menu');

  if (toggleBtn && menu) {
    function closeMenu() {
      menu.classList.remove('is-visible');
      menu.classList.add('is-hidden');
      toggleBtn.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      menu.classList.add('is-visible');
      menu.classList.remove('is-hidden');
      toggleBtn.setAttribute('aria-expanded', 'true');
    }

    toggleBtn.addEventListener('click', function (event) {
      event.stopPropagation();
      var isOpen = toggleBtn.getAttribute('aria-expanded') === 'true';
      if (isOpen) { closeMenu(); } else { openMenu(); }
    });

    document.addEventListener('click', function (event) {
      if (!menu.contains(event.target) && !toggleBtn.contains(event.target)) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { closeMenu(); }
    });
  }

  // --- Mobile promos Flickity ---
  var mobilePromos = document.querySelector('.custom-promos-wrapper.custom-mobile-promos');
  if (mobilePromos) {
    new Flickity(mobilePromos, {
      freeScroll: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      watchCSS: true
    });
  }

  // --- Content slider Flickity ---
  setTimeout(function() {
    var sliderEl = document.querySelector('.custom-content-slider-slider');
    if (sliderEl) {
      new Flickity(sliderEl, {
        freeScroll: false,
        contain: true,
        prevNextButtons: true,
        pageDots: true,
        wrapAround: true,
        cellAlign: 'left',
      });
    }
  }, 150);

});
